import { owaDate, addDays } from 'owa-datetime';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export function setGoalDateProperties(event: Partial<CalendarEvent>, date: string, tz: string) {
    event.IsAllDayEvent = true;
    event.Start = owaDate(tz, date);
    event.StartTimeZoneId = tz;
    event.End = addDays(owaDate(tz, date), 1);
    event.EndTimeZoneId = tz;
    return event;
}
